import { useNavigate } from 'react-router';
import { DoubleTextElipsisWithTooltip, ProblemIconWithTooltip, useObserver } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Table } from 'ui/table/Table';
import { AppRouteWithParams } from 'routing/AppRoute.enum';

import { ModifyWantedInformationContainer } from './modifyWantedInformation/ModifyWantedInformationContainer';
import { WantedTableRowProps } from './WantedTableRow.types';
import { DeleteWantedContainer } from './deleteWanted/DeleteWantedContainer';
import * as Styled from './WantedTableRow.styles';

export const WantedTableRow = ({ owner }: WantedTableRowProps) => {
  const { formatMessage } = useLocale();
  const { tableWidth } = useObserver();
  const navigate = useNavigate();

  return (
    <>
      <Table.RowItem>{owner.skdId}</Table.RowItem>

      <Table.RowItem>
        <DoubleTextElipsisWithTooltip
          fullText={`${owner.nazwisko} ${owner.imie}`}
          firstLineText={owner?.nazwisko}
          secondLineText={owner?.imie}
          width={tableWidth}
        />
      </Table.RowItem>

      <Table.RowItem>
        <ProblemIconWithTooltip
          isError={owner.problemTkd}
          tooltip={formatMessage({ id: AppMessages['wanted.notUpdated.info'] })}
        />
      </Table.RowItem>

      <Table.RowCellsItem cells={owner.komorka} />

      <Table.RowItem>{owner.nrEwidencyjny}</Table.RowItem>

      <Table.RowItem>
        <Styled.Wrapper>
          <Styled.TerminalsIcon onClick={() => navigate(AppRouteWithParams.wantedReaders.get({ id: owner.id }))} />
          <ModifyWantedInformationContainer owner={owner} />
          <DeleteWantedContainer owner={owner} />
        </Styled.Wrapper>
      </Table.RowItem>
    </>
  );
};
